import React, {useState, useEffect} from 'react'
import {useNavigate} from 'react-router-dom'
import "../Styles/Products.css"
import Product from '../Models/ProductModels'
import productsData from "../JSON/popularProducts.json"
import Color from '../Components/Colors/Color'
import { useStateContext } from '../Contexts/productsCardContext'
import ClipLoader from "react-spinners/ClipLoader"
import "../Admin/Components/Overlay/Overlay.css"
import { fetchProducts } from '../Admin/Controller/ProductController'

const Products = () => {

  const navigate = useNavigate();

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);


  const handleMoveToProducts = () => {
      navigate("./products")
  }

  const handleMoveToProductDetails = (product) =>{
    navigate(`/products/detail?id=${product.id}`)
  }

  const shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  useEffect(() => {
        
    const handleFetchProducts = async () => {
        try{
            setLoading(true);
            const response = await fetchProducts();
            const productList = response.data.products;
            console.log(productList);
            const sortedProducts = productList.sort((a, b) => a.name.localeCompare(b.name));
            const shuffledProducts = shuffleArray(sortedProducts); // Shuffle the products
            setProducts(shuffledProducts || [])

        }catch(error)  {
            console.log(error?.response?.data?.message || "An error occurred");
        }finally{
          setLoading(false);
        }
    }
    
    handleFetchProducts();
},[])
  

  return (
    <div className='featured-products h-auto text-[3.5rem] md:text-[4rem] lg:text-[4rem] xl:text-[4.5rem] text-background text-center font-fugaz products-container'>
        <h2 className='mb-5 products-header'>
            Popular Products
        </h2>
        <div className='grid md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 place-items-center gap-10 xl:gap-20 mb-6 products-list-container'>
          {!loading && products.slice(0, 3).map((product) => {
            return(
              <div className='products-card' onClick={() => handleMoveToProductDetails(product)} key = {product.id}>
                <Product product = {product}/>
              </div>
            )
          })}
        </div>
        <div className={`loading-container-overlay-small ${loading ? "" : "stop"}`}>
            <ClipLoader size={100} color='black' />
        </div>
         {/* <button className='bg-background text-white self-start w-40 h-16 rounded-2xl lg:w-52 lg:h-20 lg:rounded-3xl text-2xl font-lato'> */}
        <button className='products-btn ' style={{backgroundColor: Color.primaryBackground, color: Color.secondaryText}} onClick={handleMoveToProducts}>
            See More
        </button>
    </div>
  )
}

export default Products;